export default __webpack_public_path__ + "static/media/Metal007_1K_Displacement.7a69e551.jpg";